import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ContactForm from './ContactForm';
import './KimoneSellsOrlando.css';
import './KimoneSellsOrlandoBuy.css';

const KimoneSellsOrlandoBuy = () => {
  const [showForm, setShowForm] = useState(false);
  const [showSocialPopup, setShowSocialPopup] = useState(false);
  const qrCode = `KIMONE_BUYING_${Date.now()}`;

  const handleContactClick = () => {
    setShowForm(true);
  };

  return (
    <div className="kimone-sells-orlando">
      <Helmet>
        <title>Buying a Home in Orlando | Kimone Campbell | LPT Realty</title>
        <meta name="description" content="Ready to buy a home in Central Florida? Let Kimone Campbell guide you through every step of the home buying process. Expert Orlando real estate services." />
        <meta name="keywords" content="buy home Orlando, Orlando home buyer, first time home buyer Orlando, Central Florida homes for sale, Kimone Campbell realtor" />
      </Helmet>

      {/* Header with Navigation */}
      <header className="kso-header">
        <div className="kso-header-content">
          <div className="kso-logo">
            <img src="/media/kimone/logo.png" alt="LPT Realty" className="kso-lpt-logo" />
            <div className="kso-logo-text">
              <h1><Link to="/kimone-sells-orlando" style={{color: 'inherit', textDecoration: 'none'}}>KIMONE CAMPBELL</Link></h1>
              <p className="kso-subtitle">Your Trusted Orlando Real Estate Guide</p>
            </div>
          </div>
          <nav className="kso-nav">
            <Link to="/kimone-sells-orlando">Home</Link>
            <Link to="/kimone-sells-orlando/buy" className="kso-nav-active">Buying</Link>
            <Link to="/kimone-sells-orlando/sell">Selling</Link>
            <Link to="/kimone-sells-orlando#properties">Properties</Link>
            <Link to="/kimone-sells-orlando#reviews">Reviews</Link>
            <Link to="/kimone-sells-orlando#about">About</Link>
            <Link to="/kimone-sells-orlando#contact" className="kso-nav-cta">Contact</Link>
          </nav>
          <div className="kso-header-icons">
            <a href="mailto:kimone@lptrealty.com" className="kso-icon-link" title="Email">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </a>
            <a href="tel:321-522-2149" className="kso-icon-link" title="Call (321) 522-2149">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
            </a>
            <button className="kso-icon-link kso-user-button" onClick={() => setShowSocialPopup(!showSocialPopup)} title="Sign up or Sign in">
              <svg className="kso-user-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="kb-hero">
        <div className="kb-hero-overlay"></div>
        <div className="kb-hero-content">
          <h2 className="kb-hero-title">Buying a Home in Orlando</h2>
          <p className="kb-hero-subtitle">Who you work with matters.</p>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="kb-intro">
        <div className="kso-container">
          <p className="kb-intro-text">
            Buying a home is one of the biggest decisions you'll ever make. Whether you're a first-time buyer
            or an experienced investor, having the right guide by your side makes all the difference.
            I'm here to help you navigate Central Florida's real estate market with confidence.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="kb-services">
        <div className="kso-container">
          <h2 className="kso-section-title">How I Help You Buy</h2>

          <div className="kb-services-grid">
            <div className="kb-service-card">
              <div className="kb-service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                </svg>
              </div>
              <h3>Property Search Access</h3>
              <p>Get access to every home for sale in Central Florida through my advanced property search. See listings before they hit the major websites and find hidden gems that match your criteria.</p>
            </div>

            <div className="kb-service-card">
              <div className="kb-service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
              </div>
              <h3>Instant Alerts</h3>
              <p>Be the first to know when new properties hit the market. I'll set you up with instant notifications for homes that match your preferences, price range, and desired neighborhoods.</p>
            </div>

            <div className="kb-service-card">
              <div className="kb-service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="M12 8v8"/>
                  <path d="M8 12h8"/>
                </svg>
              </div>
              <h3>Mortgage Guidance</h3>
              <p>Understanding your financing options is crucial. I'll connect you with trusted lenders who can get you pre-approved and help you understand exactly what you can afford.</p>
            </div>

            <div className="kb-service-card">
              <div className="kb-service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3>Expert Representation</h3>
              <p>From your first showing to closing day, I'll be by your side. I handle negotiations, paperwork, inspections, and all the details so you can focus on finding your perfect home.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Process */}
      <section className="kb-process">
        <div className="kso-container">
          <h2 className="kso-section-title">The Home Buying Process</h2>

          <div className="kb-process-steps">
            <div className="kb-step">
              <div className="kb-step-number">1</div>
              <h3>Get Pre-Approved</h3>
              <p>Know your budget before you start looking. I'll connect you with lenders who can get you pre-approved quickly.</p>
            </div>

            <div className="kb-step">
              <div className="kb-step-number">2</div>
              <h3>Define Your Needs</h3>
              <p>We'll discuss your must-haves, nice-to-haves, and deal-breakers to narrow down the perfect neighborhoods and home types.</p>
            </div>

            <div className="kb-step">
              <div className="kb-step-number">3</div>
              <h3>Tour Homes</h3>
              <p>I'll schedule showings that fit your schedule and provide insights about each property and neighborhood.</p>
            </div>

            <div className="kb-step">
              <div className="kb-step-number">4</div>
              <h3>Make an Offer</h3>
              <p>When you find "the one," I'll help you craft a competitive offer and negotiate the best terms on your behalf.</p>
            </div>

            <div className="kb-step">
              <div className="kb-step-number">5</div>
              <h3>Close with Confidence</h3>
              <p>I'll guide you through inspections, appraisals, and closing paperwork to ensure a smooth transaction.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Areas Served */}
      <section className="kb-areas">
        <div className="kso-container">
          <h2 className="kso-section-title">Areas I Serve</h2>
          <div className="kb-areas-grid">
            <div className="kb-area">Orlando</div>
            <div className="kb-area">Kissimmee</div>
            <div className="kb-area">Winter Park</div>
            <div className="kb-area">Lake Nona</div>
            <div className="kb-area">Dr. Phillips</div>
            <div className="kb-area">Windermere</div>
            <div className="kb-area">Celebration</div>
            <div className="kb-area">Ocoee</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="kb-cta">
        <div className="kso-container">
          <h2>Ready to Find Your Dream Home?</h2>
          <p>Let's start your home search today. Contact me for a free buyer consultation.</p>
          <div className="kb-cta-buttons">
            <button className="kso-cta-button" onClick={handleContactClick}>
              Contact Me Today
            </button>
            <a href="tel:321-522-2149" className="kb-phone-button">
              Call (321) 522-2149
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="kso-footer">
        <div className="kso-container">
          <div className="kso-footer-content">
            <div className="kso-footer-section">
              <h3>Kimone Campbell</h3>
              <p>Real Estate Agent</p>
              <p>LPT Realty LLC</p>
              <p>License #: SL3468311</p>
            </div>

            <div className="kso-footer-section">
              <h3>Contact</h3>
              <p>Phone: (321) 522-2149</p>
              <p>Email: kimone@lptrealty.com</p>
              <p>Orlando, FL</p>
            </div>

            <div className="kso-footer-section">
              <h3>Follow Me</h3>
              <div className="kso-social-links">
                <a href="https://www.youtube.com/@homesbykimone" target="_blank" rel="noopener noreferrer">YouTube</a>
                <a href="https://www.facebook.com/kimonesellsorlando" target="_blank" rel="noopener noreferrer">Facebook</a>
                <a href="https://www.instagram.com/kimonesellsorlando" target="_blank" rel="noopener noreferrer">Instagram</a>
                <a href="https://www.linkedin.com/in/kimone-campbell" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              </div>
            </div>
          </div>

          <div className="kso-footer-bottom">
            <p>&copy; 2025 Kimone Campbell. All Rights Reserved.</p>
            <div className="kso-footer-links">
              <a href="/privacy.html">Privacy Policy</a>
              <span>|</span>
              <a href="/tos.html">Terms of Use</a>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Form Modal */}
      {showForm && (
        <ContactForm
          qrCode={qrCode}
          onClose={() => setShowForm(false)}
        />
      )}

      {/* Sign In Popup */}
      {showSocialPopup && (
        <div className="kso-social-popup-overlay" onClick={() => setShowSocialPopup(false)}>
          <div className="kso-social-popup" onClick={(e) => e.stopPropagation()}>
            <button className="kso-popup-close" onClick={() => setShowSocialPopup(false)}>×</button>
            <h2 className="kso-popup-title">Sign In</h2>
            <div className="kso-popup-content">
              <p>Sign in to save your favorite properties and searches.</p>
              <form className="kso-signin-form">
                <input type="email" placeholder="Enter your email" className="kso-form-input" />
                <input type="tel" placeholder="Enter your phone number" className="kso-form-input" />
                <input type="submit" value="Log in" className="kso-submit-button" />
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KimoneSellsOrlandoBuy;
